import PropTypes from 'prop-types';
import React from 'react';
import ControlledWidthContainer from '../../components/Community/Sections/ControlledWidthContainer/ControlledWidthContainer';
import ShareIconSection from '../../components/Elements/ShareIconSection/ShareIconSection';
import UnderlineNavigation from '../../components/Elements/UnderlineNavigation/UnderlineNavigation';
import PageNav from '../../components/JobComponents/Pagination/PageNav/PageNav';
import ContentContainerSideBar from '../../components/Layout/ContentContainerSideBar/ContentContainerSideBar';
import Layout from '../../components/Layout/Layout';
import PageSection from '../../components/Layout/PageSection/PageSection';
import PostNow from '../../components/Wrappers/PostNow/PostNow';
import { PAGE_PROPS } from '../defaultProps';
import { getUrl } from './getUrl';
import CompanyResults from './Results/Company';
import JobResults from './Results/Job';
import GroupResults from './Results/Group';
import UserResults from './Results/User';
import CommunityResults from './Results/Community';
import Sidebar from './Sidebar';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import './Search.scss';

const Search = ({
    PAGE_PROPS: pageProps,
    menuItems = [],
    total,
    mainSearchBar,
    topics,
    sideBarFixed,
    pagination,
    isSingleSearch,
    results,
}) => {
    const hasResultsToDisplay = !!total;
    return (
        <div className="page-Search">
            <SnowplowPageViewTracker
                pageType={PAGE_VIEW_TYPES.COLLECTION}
                pageSection={PAGE_VIEW_SECTIONS.SEARCH}
            />
            <Layout PAGE_PROPS={pageProps}>
                <ContentContainerSideBar
                    sideBarContent={
                        <Sidebar meta={pageProps.meta} topics={topics} />
                    }
                    horizontalBarContent={
                        <ShareIconSection
                            meta={pageProps.meta}
                            orientation="landscape"
                        />
                    }
                    sideBarFixed={sideBarFixed}
                    mainSectionColClass="col-xl-10"
                    sidebarColClass="col-xl-2"
                >
                    <PageSection>
                        <ControlledWidthContainer>
                            <div>
                                <div className="result-section-title pt-4">
                                    {total} Results
                                </div>
                                {mainSearchBar.term ? (
                                    <div className="sub-title">
                                        &quot;{mainSearchBar.term}&quot;
                                    </div>
                                ) : null}
                                {menuItems.length ? (
                                    <div className="mt-3 mb-5">
                                        <UnderlineNavigation
                                            menuItems={menuItems}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            {hasResultsToDisplay ? (
                                <div className="results">
                                    <JobResults
                                        results={results?.job}
                                        url={getUrl('job', mainSearchBar.term)}
                                        isSingleSearch={isSingleSearch}
                                        session={pageProps.session}
                                    />
                                    <CompanyResults
                                        url={getUrl(
                                            'company',
                                            mainSearchBar.term
                                        )}
                                        isSingleSearch={isSingleSearch}
                                        results={results?.company?.results}
                                        total={results?.company?.total}
                                    />
                                    <UserResults
                                        url={getUrl('user', mainSearchBar.term)}
                                        isSingleSearch={isSingleSearch}
                                        results={results?.user}
                                    />
                                    <GroupResults
                                        url={getUrl(
                                            'group',
                                            mainSearchBar.term
                                        )}
                                        isSingleSearch={isSingleSearch}
                                        results={results?.group}
                                    />
                                    <CommunityResults
                                        results={results}
                                        searchBarTerm={mainSearchBar.term}
                                        isSingleSearch={isSingleSearch}
                                    />
                                    {pagination ? (
                                        <PageNav
                                            prevUrl={pagination.prevUrl}
                                            nextUrl={pagination.nextUrl}
                                        />
                                    ) : null}
                                </div>
                            ) : (
                                <PostNow
                                    topics={topics}
                                    message={
                                        <div className="no-results">
                                            <div>
                                                Maybe FGB&apos;ers can help.
                                            </div>
                                            <div>
                                                Ask the community your question.
                                            </div>
                                        </div>
                                    }
                                />
                            )}
                        </ControlledWidthContainer>
                    </PageSection>
                </ContentContainerSideBar>
            </Layout>
        </div>
    );
};

export default Search;

Search.propTypes = {
    sideBarFixed: PropTypes.bool,
    /**
     * Global props from the server
     */
    PAGE_PROPS,
    mainSearchBar: PropTypes.shape({
        term: PropTypes.string,
        page: PropTypes.number,
        type: PropTypes.string,
        placeholder: PropTypes.string,
    }).isRequired,
    isSingleSearch: PropTypes.bool.isRequired,
    total: PropTypes.number.isRequired,
    results: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    pagination: PropTypes.shape({
        prevUrl: PropTypes.string,
        nextUrl: PropTypes.string,
    }),
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            active: PropTypes.bool,
            total: PropTypes.number,
        })
    ),
    topics: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};

Search.defaultProps = {
    sideBarFixed: false,
    PAGE_PROPS: { url: { path: '/' } },
    pagination: null,
    menuItems: [],
};
